// Componente otros.vue
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div style='text-align:justific' slot="header">
            <strong class="izquierda">Filtros del Informe</strong>
            <strong class="derecha">GARANTÍA</strong>
          </div>

          <b-row>
            <b-col sm="3">
                <b-form-group
                  label="Ejecutivos"
                  >
                  <b-form-select
                    :options="valEjecutivos"
                    v-model="datosFormulario.codejecutivo"
                    :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                  ></b-form-select>

                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.codejecutivo }}</span>
                </b-form-group>
            </b-col>

          </b-row>
          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>           
                </el-col>
              </el-row>
            </div>
          </div>  
           </b-card>
           <b-row>
      <b-col>  
          <div>
          <b-alert variant="info" show>
            Casos IMP, JUD y con Precautoria: {{datosFormulario.cantotros}}
          </b-alert>
          </div>            
      </b-col>
    </b-row>

         <b-card>
            <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input size="sm"
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange"           
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >

                    <template slot-scope="scope">
                      <div v-if="title.prop == 'SINIESTRO'">  
                          <b-link type="text"  @click="VerSiniestro(scope.row)"> {{scope.row.SINIESTRO}}</b-link>      
                      </div> 
                      
                      <div v-if="title.prop == 'CODLIQ'">  
                          <b-link type="text"  @click="recuperar_liquidador(scope.row.CODLIQ)"> {{scope.row.CODLIQ}}</b-link>     
                      </div> 
                      <!-- <p v-else-if="title.prop != 'SINIESTRO'">{{scope.row[title.prop]}}</p> -->
                      <p v-else-if="title.prop != 'SINIESTRO'">{{formatter(scope.row,scope.column)}}</p>
                    </template>
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <!-- Nombre Liquidador -->
    <b-modal
      size="sm"
      ok-only
      title= "Nombre Liquidador" 
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalLiquidador"
      @ok="modalLiquidador = false"
      @cancel="modalLiquidador = false"
    >
      <b-row>
        <b-col lg="12">
          <div ref="refTable">
            <data-tables
              ref="refTable3"
              :data="dataLiquidador"
              name="table"
              class="table-responsive"
              :current-page.sync="pagina"
              :page-size="10"
              :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
              layout="table">
              <el-table-column
                v-for="title in titlesLiquidador"
                :min-width="title.minwidth"
                :prop="title.prop"
               
                :key="title.label"
                :align="title.align" 
                :formatter="formattermd"
                name="table"
                class="table-responsive">
              </el-table-column>
            </data-tables>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    
    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>
    
  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarSiniestros from "@/components/services/apiGarSiniestros";
import apiGarSeguimiento from "@/components/services/apiGarSeguimiento";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  // name: "Polizas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {

    poliza: String,
    cod_asegurado: String,
    participacion: Number,
    fedesde: Datepicker,
    fehasta: Datepicker
 
  },

  components: {
    cSwitch
  },

  data: function() {
    return {
      tabIndex: 1,
      tieneAcceso: true,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      mostrar:false,
      
      variant: "",
      mensaje: "",

      data: [],
      dataLiqPer: [],

      dataLiquidador: [],

      multipleSelection: [],

      modalLiquidador: false,

      datosFormulario: {
        nomliquidador: "",
        codejecutivo: "",
        modaltitle:"",
        cantotros:""
     },

      titles: [
        {
          prop: "SINIESTRO",
          label: "Siniestro",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "PRODUCTO",
          label: "Producto",
          align: "left",
          minwidth:'100'
        },    
        {
          prop: "ESTADO",
          label: "Estado",
          align: "left",
          minwidth:'100'
        },      
        {
          prop: "AFIANZADO",
          label: "Afianzado",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario",
          align: "left",
          minwidth:'300'
        },      
        {
          prop: "MONPOL",
          label: "Mon. Pol.",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "MTODENUN",
          label: "Monto Den.",
          align: "right",
          minwidth:'150'
        },          
        {
          prop: "EJESIN",
          label: "Eje. Sin.",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "ASISIN",
          label: "Asi. Sin.",
          align: "center",
          minwidth:'100'
        },   
        {
          prop: "FEDENUN",
          label: "Fe. Den.",
          align: "center",
          minwidth:'120'
        },  
        {
          prop: "FECONFIG",
          label: "Fe. Est. Conf.",
          align: "center",
          minwidth:'120'
        },  
        {
          prop: "FEINFLIQ",
          label: "Fe. Inf. Liq.",
          align: "center",
          minwidth:'100'
        },    
        {
          prop: "CODLIQ",
          label: "Cod. Liq.",
          align: "right",
          minwidth:'100'
        },
        {
          prop: "NOMINA",
          label: "Nómina",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "FEPAGO",
          label: "Fe. Pago",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "AUTORIZADO",
          label: "Autorizado",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "OBSERVACION",
          label: "Observaciones",
          align: "left",
          minwidth:'300'
        }
        
      ],

      titlesLiquidador: [
        {
          prop: "NOMLIQUIDADOR",
          label: "Liquidador",
          align: "center",
          minwidth: "100",
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      mensajeValidacionCampo: {},
      valEjecutivos: [],

      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "Siniestro"
      },

      tablePropsLiqPer:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400,
          rowKey: "Siniestro"
      }
   
    }
  },

  components:{
    Datepicker,
    Multiselect
  },

  methods: {

    formatter(row, column) {

      //  console.log('cualquier cosa', row.MONPOL, column);

      if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO"||column.property == "MTODENUN") && row[column.property]) {
            console.log(row[column.property]);
            if (row.MONPOL == "$"){
              return this.$numeral(row[column.property]).format("0,0");
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }

    },

    formattermd(row, column) {
          if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
        },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Siniestros en Proceso</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["SINIESTRO"] == undefined){
          this.data[key]["SINIESTRO"] = "";
        }
        if(this.data[key]["POLIZA"] == undefined){
          this.data[key]["POLIZA"] = "";
        }
        if(this.data[key]["PRODUCTO"] == undefined){
          this.data[key]["PRODUCTO"] = "";
        }
        if(this.data[key]["ESTADO"] == undefined){
          this.data[key]["ESTADO"] = "";
        }
        if(this.data[key]["AFIANZADO"] == undefined){
          this.data[key]["AFIANZADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["MONPOL"] == undefined){
          this.data[key]["MONPOL"] = "";
        }
        if(this.data[key]["MTODENUN"] == undefined){
          this.data[key]["MTODENUN"] = "";
        }
        if(this.data[key]["EJESIN"] == undefined){
          this.data[key]["EJESIN"] = "";
        }
        if(this.data[key]["ASISIN"] == undefined){
          this.data[key]["ASISIN"] = "";
        }
        if(this.data[key]["FEDENUN"] == undefined){
          this.data[key]["FEDENUN"] = "";
        }
        if(this.data[key]["FECONFIG"] == undefined){
          this.data[key]["FECONFIG"] = "";
        }
        if(this.data[key]["FEINFLIQ"] == undefined){
          this.data[key]["FEINFLIQ"] = "";
        }
        if(this.data[key]["CODLIQ"] == undefined){
          this.data[key]["CODLIQ"] = "";
        }
        if(this.data[key]["NOMINA"] == undefined){
          this.data[key]["NOMINA"] = "";
        }
        if(this.data[key]["FEPAGO"] == undefined){
          this.data[key]["FEPAGO"] = "";
        }
        if(this.data[key]["AUTORIZADO"] == undefined){
          this.data[key]["AUTORIZADO"] = "";
        }
        if(this.data[key]["OBSERVACION"] == undefined){
          this.data[key]["OBSERVACION"] = "";
        }
        

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["POLIZA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRODUCTO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ESTADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["AFIANZADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONPOL"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MTODENUN"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJESIN"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASISIN"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FEDENUN"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FECONFIG"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FEINFLIQ"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["CODLIQ"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["NOMINA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FEPAGO"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["AUTORIZADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["OBSERVACION"] + "</td>\n";
        cuerpo += "</tr>\n";
      }


      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },    

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
      return apiGarSeguimiento
        .pre_insertar_otros(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          // Carga lista de ejecutivos
          this.valEjecutivos = this.llenaArrayLista(response.data.ejecutivos, 'codejecutivo', 'des_ejecutivo', false);
          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
             this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
             this.datosFormulario.feiniciov = lista_data[i]["feinicio"];
             this.datosFormulario.fefinv = lista_data[i]["fefin"];
          }

          this.tabIndex = this.$route.query.tabIndexOrig;
          this.buscar();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
            this.$Progress.start(); 
           
            return apiGarSeguimiento
              .recuperar_otros(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.codejecutivo
              )  
              .then(response => {
                
                this.data = response.data.res;
                this.pagina = this.paginaAnterior;
                this.$Progress.finish();
                this.datosFormulario.cantotros = response.data.args_out.cantotros;
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
        },

     VerSiniestro(row){
        this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'seguimientosiniestro' ,  
                                                         origen: 'seguimientosiniestro',
                                                         destino: 'CrearSiniestro',
                                                         tabIndexOrig: 0,
                                                         tabIndexDest: 2,
                                                         nroCorrespondencia: '',
                                                         nroSiniestro: row.SINIESTRO,
                                                         nroPoliza: row.POLIZA,
                                                         ejecutivo: '',
                                                         asistente: '',
                                                         tag: 3 }});
    },
   
     recuperar_liquidador(p_liquidador){
      apiGarSeguimiento
          .recuperar_liquidador(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_liquidador
          )
          .then(response => {
            this.dataLiquidador = response.data.res;
       
            // this.datosFormulario.nomliquidador = p_liquidador;
            
            this.$Progress.finish();
            this.modalLiquidador = true;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

      export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },
    
    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor];
            obj.text = data[i][texto];
          }
          arr.push(obj);
          
      }
      return arr;
    },
  },
      
  mounted() {
     this.pagina = Number(this.$route.query.pagina);
     this.pre_insertar();
  },
 watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

 data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            if (lista[index]["chk"] == "1"){
              this.toggleSelection([lista[index]]);
            }
        }
      })
    } 
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>

.derecha   { float: right; color: #20a8d8;}
.izquierda { float: left;  }

  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}

.label-blanco{
  color: #fff;
}
</style>